// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IInvoiceBriefRecordDto
 */
export interface IInvoiceBriefRecordDto {
    /**
     * 
     * @type {Date}
     * @memberof IInvoiceBriefRecordDto
     */
    invoice_close_date?: Date;
    /**
     * 
     * @type {number}
     * @memberof IInvoiceBriefRecordDto
     */
    invoice_amount?: number;
}

/**
 * Check if a given object implements the IInvoiceBriefRecordDto interface.
 */
export function instanceOfIInvoiceBriefRecordDto(value: object): value is IInvoiceBriefRecordDto {
    return true;
}

export function IInvoiceBriefRecordDtoFromJSON(json: any): IInvoiceBriefRecordDto {
    return IInvoiceBriefRecordDtoFromJSONTyped(json, false);
}

export function IInvoiceBriefRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IInvoiceBriefRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'invoice_close_date': json['invoice_close_date'] == null ? undefined : (new Date(json['invoice_close_date'])),
        'invoice_amount': json['invoice_amount'] == null ? undefined : json['invoice_amount'],
    };
}

export function IInvoiceBriefRecordDtoToJSON(json: any): IInvoiceBriefRecordDto {
    return IInvoiceBriefRecordDtoToJSONTyped(json, false);
}

export function IInvoiceBriefRecordDtoToJSONTyped(value?: IInvoiceBriefRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'invoice_close_date': value['invoice_close_date'] == null ? undefined : ((value['invoice_close_date']).toISOString().substring(0,10)),
        'invoice_amount': value['invoice_amount'],
    };
}

